import { motion } from 'motion/react';

import { useTranslation } from '../i18n/hooks';

export default function HeroSection() {
  const t = useTranslation();
  return (
    <section
      id="hero"
      className="relative mt-32 px-4 py-12 text-center sm:px-6 sm:py-16 md:px-8 md:py-20 lg:mt-52 lg:px-32"
    >
      {/* Background Pattern */}
      <div className="pointer-events-none absolute top-0 left-0 h-full w-full overflow-hidden">
        <motion.div
          className="absolute top-[-150px] right-[-100px] h-[400px] w-[400px] sm:top-[-200px] sm:right-[-50px] sm:h-[600px] sm:w-[600px] md:top-[-270px] md:right-[50px] md:h-[800px] md:w-[800px] lg:right-[137px] lg:h-[1141px] lg:w-[1166px]"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 1.5, ease: 'easeOut' }}
        >
          <img
            src="/images/hero-pattern.svg"
            alt=""
            className="h-full w-full object-contain"
          />
        </motion.div>
      </div>

      <motion.div
        className="relative z-10 mx-auto max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-4xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <motion.h1
          className="mb-4 px-2 text-2xl leading-tight font-bold text-gray-900 sm:mb-6 sm:text-3xl md:text-4xl lg:text-5xl"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1, duration: 0.8, ease: 'easeOut' }}
        >
          <span className="text-[#2ab25e]">{t.hero.title}</span>
        </motion.h1>
        <motion.h2
          className="mb-4 px-2 text-xl leading-tight font-bold text-gray-900 sm:mb-6 sm:text-2xl md:text-3xl lg:text-4xl"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.1, duration: 0.8, ease: 'easeOut' }}
        >
          {t.hero.subtitle}
        </motion.h2>
        <motion.p
          className="mx-auto mb-6 max-w-full px-2 text-base leading-relaxed text-gray-900 sm:mb-8 sm:max-w-2xl sm:text-lg md:max-w-4xl md:text-xl lg:max-w-5xl lg:text-2xl"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.3, duration: 0.8, ease: 'easeOut' }}
        >
          {t.hero.description}
        </motion.p>
        <motion.button
          className="mx-auto w-full max-w-xs rounded-md bg-green-600 px-6 py-2.5 text-sm font-bold text-white transition-colors hover:bg-green-700 sm:w-auto sm:px-20 sm:py-3 sm:text-base md:px-20 lg:px-28"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.6, duration: 0.6, ease: 'easeOut' }}
          whileHover={{
            scale: 1.05,
            backgroundColor: '#15803d',
            boxShadow: '0 10px 25px rgba(34, 197, 94, 0.3)',
          }}
          whileTap={{ scale: 0.95 }}
        >
          <a
            href="https://patient.tc.tgl.com.sa/signin"
            target="_blank"
            rel="noreferrer"
            className="whitespace-nowrap"
          >
            {t.hero.ctaButton}
          </a>
        </motion.button>
      </motion.div>
    </section>
  );
}
